(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pot-glass-dock"]) return;
  try {
    
  if (!customElements.get('pot-glass-dock')) {
    customElements.define('pot-glass-dock', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.swipeButton = this.querySelector('[data-dock-swipe]');
        this.track = this.querySelector('[data-dock-track]');
        this.cards = [...this.querySelectorAll('[data-dock-card]')];
        this.previous = this.querySelector('[data-dock-previous]');
        this.next = this.querySelector('[data-dock-next]');
        this.aiButton = this.querySelector('[data-dock-ai]');
        this.swipeButton.addEventListener('click', () => { this.dialog.showModal(); this.updatePosition(); });
        this.querySelector('[data-dock-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('close', () => this.swipeButton.focus({preventScroll: true}));
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        });
        this.previous.addEventListener('click', () => this.move(-1));
        this.next.addEventListener('click', () => this.move(1));
        this.track.addEventListener('scroll', () => { clearTimeout(this.scrollTimer); this.scrollTimer = setTimeout(() => this.updatePosition(), 100); }, {passive: true});
        this.track.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1); }
        });
        this.aiButton.addEventListener('click', event => {
          event.stopPropagation();
          const launcher = this.findInboxLauncher();
          if (launcher) launcher.click();
        });
        this.cartObserver = new MutationObserver(() => this.updateCart());
        const headerCart = document.getElementById('cart-icon-bubble');
        if (headerCart) this.cartObserver.observe(headerCart, {subtree: true, childList: true, characterData: true});
        this.chatObserver = new MutationObserver(() => this.bindInbox());
        this.chatObserver.observe(document.body, {childList: true, subtree: true});
        this.chatTimer = setInterval(() => this.bindInbox(), 500);
        this.chatPollEnd = setTimeout(() => clearInterval(this.chatTimer), 20000);
        this.bindInbox();
        this.updatePosition();
      }
      disconnectedCallback() { clearInterval(this.chatTimer); clearTimeout(this.chatPollEnd); clearTimeout(this.scrollTimer); this.cartObserver?.disconnect(); this.chatObserver?.disconnect(); this.chatRootObserver?.disconnect(); this.runtimeRootObserver?.disconnect(); document.body.classList.remove('pot-dock-inbox-ready'); }
      findInboxLauncher() {
        const root = document.querySelector('shopify-chat')?.shadowRoot;
        return root?.querySelector('button[part~="activator"]') || root?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('button[part~="activator"]');
      }
      bindInbox() {
        const root = document.querySelector('shopify-chat')?.shadowRoot;
        if (root && root !== this.chatRoot) {
          this.chatRoot = root;
          this.chatRootObserver?.disconnect();
          this.chatRootObserver = new MutationObserver(() => this.bindInbox());
          this.chatRootObserver.observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['part']});
        }
        const runtimeRoot = root?.querySelector('shopify-agent-runtime')?.shadowRoot;
        if (runtimeRoot && runtimeRoot !== this.runtimeRoot) {
          this.runtimeRoot = runtimeRoot;
          this.runtimeRootObserver?.disconnect();
          this.runtimeRootObserver = new MutationObserver(() => this.bindInbox());
          this.runtimeRootObserver.observe(runtimeRoot, {childList: true, subtree: true, attributes: true, attributeFilter: ['part']});
        }
        const launcher = this.findInboxLauncher();
        if (!launcher || launcher === this.launcher) return;
        this.launcher = launcher;
        this.aiButton.disabled = false;
        this.aiButton.removeAttribute('title');
        document.body.classList.add('pot-dock-inbox-ready');
        clearInterval(this.chatTimer);
      }
      updateCart() {
        const header = document.getElementById('cart-icon-bubble');
        const headerCount = header?.querySelector('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble, .bal-cart-count, [data-cart-count], :scope > span[aria-hidden="true"]');
        const count = Number((headerCount?.textContent || '0').trim().split(/\s/)[0]);
        const badge = this.querySelector('[data-dock-count]');
        badge.textContent = String(count);
        badge.hidden = count === 0;
      }
      updatePosition() {
        const width = this.track.clientWidth + 16;
        this.index = Math.max(0, Math.min(this.cards.length - 1, Math.round(this.track.scrollLeft / width)));
        this.querySelector('[data-dock-position]').textContent = this.cards.length ? (this.index + 1) + ' / ' + this.cards.length : '';
        this.previous.disabled = this.index <= 0;
        this.next.disabled = this.index >= this.cards.length - 1;
      }
      move(direction) {
        this.updatePosition();
        const target = this.cards[Math.max(0, Math.min(this.cards.length - 1, this.index + direction))];
        if (target) this.track.scrollTo({left: target.offsetLeft - this.cards[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
